import React from 'react';
import { FaCalendarCheck, FaExternalLinkAlt } from 'react-icons/fa';

const AppointmentCalendar = ({ calendlyUrl }) => {
  const hasCalendlyUrl = calendlyUrl && calendlyUrl.trim() !== '';

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
          <FaCalendarCheck className="text-xl text-primary-600" />
        </div>
        <h3 className="text-lg font-bold text-gray-900">Book Appointment</h3>
      </div>

      {hasCalendlyUrl ? (
        <div>
          <p className="text-gray-600 text-sm mb-4">
            Schedule your next consultation with your coach or doctor.
          </p>

          {/* Calendly Embed */}
          <div className="border-2 border-gray-100 rounded-xl overflow-hidden mb-4">
            <iframe
              src={calendlyUrl}
              width="100%"
              height="400"
              frameBorder="0"
              title="Schedule Appointment"
              className="rounded-xl"
            />
          </div>

          <a
            href={calendlyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm"
          >
            Open in new tab <FaExternalLinkAlt className="text-xs" />
          </a>
        </div>
      ) : (
        <div className="text-center py-8 px-4 bg-gray-50 rounded-xl">
          <FaCalendarCheck className="text-4xl text-gray-300 mx-auto mb-3" />
          <h4 className="font-semibold text-gray-700 mb-2">Coming Soon</h4>
          <p className="text-gray-500 text-sm">
            Online appointment booking will be available soon. Your coach will contact you to schedule sessions.
          </p>
        </div>
      )}
    </div>
  );
};

export default AppointmentCalendar;
